import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import isNil from 'lodash/isNil';

let styles = {
    overlay: {
        background: 'rgba(0, 0, 0, 0.4)',
        display: 'flex',
        zIndex: 20,
        alignItems: 'center',
        justifyContent: 'center'
    },
    content: {
    }
};

const Modal = (props) => {
    const {
        className,
        preventScroll,
        contentLabel = '',
        isModalOpen = false,
        onModalAfterOpen,
        onModalClose,
        children
    } = props;

    let { customContentStyles } = props;

    styles = isNil(customContentStyles) ? styles : {
        ...styles,
        content: {
            ...styles.content,
            ...customContentStyles
        }
    };


    return (
        <ReactModal
            contentLabel={contentLabel}
            isOpen={isModalOpen}
            className={className}
            preventScroll={preventScroll}
            onAfterOpen={onModalAfterOpen}
            onRequestClose={onModalClose}
            style={styles}
            ariaHideApp={false}
        >
            {children}
        </ReactModal>
    );
};


Modal.propTypes = {
    className: PropTypes.string,
    preventScroll: PropTypes.bool,
    contentLabel: PropTypes.string,
    isModalOpen: PropTypes.bool,
    onModalAfterOpen: PropTypes.func,
    onModalClose: PropTypes.func,
    customContentStyles: PropTypes.object,
    children: PropTypes.element
};


export default Modal;